import gosearch from '@/assets/images/index/gosearch.png';
import { SearchBar } from 'antd-mobile';
import { connect } from 'dva';
import { useEffect, useRef, useState } from 'react';
import { history } from 'umi';

import HotSearch from '../HotSearch';
import styles from './index.less';

const Subnav = (props: any) => {
  const { word } = props;
  const inputRef: any = useRef(null);
  const [placeholder, setPlaceholder] = useState('');
  const [status, setStatus] = useState(false);

  const [value, setValue] = useState(word ? word : '');
  const search = (value: any) => {
    setStatus(true);
    setValue(value);
  };

  document.addEventListener('click', function (event) {
    var clickedElement = event.target;
    var div = document.getElementById('search');

    // 检查点击的元素是否是当前 div 或其内部元素
    if (clickedElement !== div && !div?.contains(clickedElement)) {
      // 用户点击了 div 之外的区域，执行相应的操作
      // 例如隐藏当前 div 或执行其他操作
      setStatus(false);
    }
  });

  return (
    <>
      <div
        className={status ? styles.Box : styles.navBox}
        style={{
          marginBottom: props.ADBgImage ? `10vh` : `0`,
        }}
      >
        <div className={styles.search} id="search">
          <SearchBar
            className={styles.searchBox}
            ref={inputRef}
            value={value}
            // placeholder={placeholder}
            showCancelButton={true}
            cancelText={' '}
            onCancel={() => {
              setValue('');
            }}
            onSubmit={(value) => {
              value &&
                history.push({
                  pathname: '/search',
                  state: { value: value },
                }),
                setStatus(false);
            }}
            onFocus={() => setStatus(true)}
            // onBlur={()=> setStatus(false)}
            onChange={(value) => search(value)}
          />
          {status && (
            <img
              src={gosearch}
              alt=""
              onClick={() => {
                value &&
                  history.push({
                    pathname: '/search',
                    state: { value: value },
                  });
                setStatus(false);
              }}
            />
          )}
        </div>
        <span className={styles.icon}></span>
      </div>
    </>
  );
};

export default connect(({ home }: any) => ({
  searchWord: home.searchWord,
  ADBgImage: home.ADBgImage,
}))(Subnav);
